import { createTheme } from '@mui/material/styles';
import { commonTokens } from './base';

export const theme = createTheme({
  palette: {
    primary: {
      main: commonTokens.colors.primary,
      dark: commonTokens.colors.primaryDark,
      light: commonTokens.colors.primaryLight,
    },
    secondary: {
      main: commonTokens.colors.secondary,
      dark: commonTokens.colors.secondaryDark,
    },
    error: {
      main: commonTokens.colors.error,
    },
    warning: {
      main: commonTokens.colors.warning,
    },
    info: {
      main: commonTokens.colors.info,
    },
    success: {
      main: commonTokens.colors.success,
    },
    background: {
      default: commonTokens.semantic.background,
      paper: commonTokens.semantic.surface,
    },
    text: {
      primary: commonTokens.semantic.textPrimary,
      secondary: commonTokens.semantic.textSecondary,
    },
  },
  
  typography: {
    fontFamily: commonTokens.typography.fontFamily.primary,
    h1: {
      fontSize: commonTokens.typography.fontSize['4xl'],
      fontWeight: commonTokens.typography.fontWeight.bold,
    },
    h2: {
      fontSize: commonTokens.typography.fontSize['3xl'],
      fontWeight: commonTokens.typography.fontWeight.bold,
    },
    h3: {
      fontSize: commonTokens.typography.fontSize['2xl'],
      fontWeight: commonTokens.typography.fontWeight.semiBold,
    },
    h4: {
      fontSize: commonTokens.typography.fontSize.xl,
      fontWeight: commonTokens.typography.fontWeight.semiBold,
    },
    h5: {
      fontSize: commonTokens.typography.fontSize.lg,
      fontWeight: commonTokens.typography.fontWeight.medium,
    },
    h6: {
      fontSize: commonTokens.typography.fontSize.base,
      fontWeight: commonTokens.typography.fontWeight.medium,
    },
    body1: {
      fontSize: commonTokens.typography.fontSize.base,
      fontWeight: commonTokens.typography.fontWeight.normal,
    },
    body2: {
      fontSize: commonTokens.typography.fontSize.sm,
      fontWeight: commonTokens.typography.fontWeight.normal,
    },
    button: {
      textTransform: 'none',
      fontWeight: commonTokens.typography.fontWeight.medium,
    },
  },
  
  shape: {
    borderRadius: 8,
  },
  
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: commonTokens.borderRadius.md,
          textTransform: 'none',
          fontWeight: commonTokens.typography.fontWeight.medium,
          padding: '0.5rem 1rem',
        },
        contained: {
          boxShadow: commonTokens.shadows.sm,
          '&:hover': {
            boxShadow: commonTokens.shadows.md,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: commonTokens.borderRadius.lg,
          boxShadow: commonTokens.shadows.sm,
          border: `1px solid ${commonTokens.semantic.border}`,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: commonTokens.borderRadius.md,
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          backgroundColor: commonTokens.semantic.backgroundSecondary,
        },
      },
    },
  },
}); 